import React from "react";

import { LogVerbose } from "../../../services/utilities";

export interface CarouselContext {
    name?: string;
    // centerize?: boolean;
    centerIndex?: number;
    looping?: boolean;
    autoPlay?: boolean;
    setAutoPlay?: (autoPlay: boolean) => void;
    autoPlayInterval?: number;
    nSlides: number,
    setNSlides: (nSlides: number) => void;
    activeIndex: number;
    // setActiveIndex: (activeIndex: number) => void;
    gotoSlide: (activeIndex: number) => void;
    gotoPreviousSlide: () => void;
    gotoNextSlide: () => void;
    onSlideClick?: (index: number) => void;
    refSlideIndex?: number;
}

export const carouselContext = React.createContext<CarouselContext>({
    activeIndex: 0,
    nSlides: 0,
    looping: false,
    autoPlay: false,
    setNSlides: (nSlides: number) => {
        LogVerbose(`setting nSlides to ${nSlides}`);
    },
    setAutoPlay: (autoPlay: boolean) => {
        LogVerbose(`setting autoPlay to ${autoPlay}`);
    },
    autoPlayInterval: 5000,
    name: 'default-carousel',
    gotoPreviousSlide: () => {
        LogVerbose('going to previous slide');
    },
    gotoNextSlide: () => {
        LogVerbose('going to next slide');
    },
    // setActiveIndex: (i: number) => {
    //     LogVerbose(`setting active index to ${i}`);
    // },
    gotoSlide: (i: number) => { LogVerbose(`jumping to slide #${i + 1}`); }
});